import { NgModule } from '@angular/core';
import { MODALS } from '@freelancer/ui/modal';

@NgModule({
  providers: [
    {
      provide: MODALS,
      useValue: () => import('./bits-modal-routes').then(m => m.bitsModals),
      multi: true,
    },
  ],
})
export class AppModalsModule {}
